import type { PracticeDetail } from "@/core/types";
import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

export async function getPractice(practiceId: string): Promise<PracticeDetail> {
  return sharedRequestsTyped.fetch_practice({ searchParams: { practiceId } });
}
